const styles = theme => ({
  content: {
    display: 'flex',
    padding: '14px 24px 14px 24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
    borderRadius: '16px',
    background: 'var(--Background-Light-Paper, #FFF)',
    borderBottomLeftRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
  },
  copy: {
    width: 40,
  },
  headerText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: '8px',
    // Mevcut stili koruyoruz, değiştirmiyoruz
    [theme.breakpoints.down(600)]: {
      flexWrap: 'wrap', // Sadece küçük ekranlarda elemanların sarmalanmasını sağlar
    },
  },
  urlContent: {
    gap: '8px',
    display: 'flex',
    width: '100%',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #F4F6F8)',
    maxWidth: '609px',
    padding: '4px 24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    [theme.breakpoints.down(600)]: {
      order: 1,
      width: '100%',
      flexBasis: '100%',
      marginTop: '12px',
    },
  },
  urlWithIcon: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  questionIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '8px',
    cursor: 'pointer',
    borderRadius: '50%',
    padding: '4px',
  },
  textContainer: {
    wordBreak: 'break-all',
    overflowWrap: 'break-word',
    display: 'inline',
  },
  link: {
    color: '#fff',
    textDecoration: 'none',
  },
  urlText: {
    alignSelf: 'stretch',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #F4F6F8)',
    borderTopRightRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
    color: 'var(--mcg-dark, #002E47)',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    alignItems: 'center',
    gap: '57px',
    padding: '0 16px',
    boxSizing: 'border-box',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '50px !important',
    },
  },
  copyText: {
    display: 'flex',
    alignItems: 'center',
    color: 'var(--Gray-Darker, #838D98)',
    gap: '57px',
    alignSelf: 'stretch',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #F4F6F8)',
    minHeight: '36px',
    borderTopLeftRadius: '0 !important',
    borderBottomLeftRadius: '0 !important',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '50px !important',
    },
  },
  close: {
    display: 'flex',
  },
  icon: {
    width: 20,
    height: 20,
    padding: 1,
    cursor: 'pointer',
  },
  template: {
    display: 'grid',
    gap: '24px',
    alignSelf: 'stretch',
    gridTemplateColumns: 'repeat(5, 1fr)', // Başlangıçta 5 kolon
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(4, 1fr)', // 4 kolon
    },
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)', // 3 kolon
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)', // 2 kolon
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr', // 1 kolon
    },
  },
  cardTop: {
    height: '90px',
    alignSelf: 'stretch',
    background: 'var(--Gray-Lighter, #E5E7EB)',
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
  },
  cardText: {
    display: 'flex',
    padding: '12px',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  column: {
    borderRadius: '16px',
    background: 'var(--mcg-white, #FFF)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: '1 0 0',
    boxShadow: '0px 2px 8px 0px rgba(145, 158, 171, 0.12)',
  },
})

export default styles
